import { DocumentActionsStatusState } from 'PdfDocumentGrid/hooks/DocumentActionsStatus.context';
import { IDocumentVersion } from 'utils/DexieDBManager';
import { ORDER_VALUES } from './FilterDocumentCards';
import { IParentDocument } from 'utils/DexieDBManager/dexieDB.models';
type Filters = {
  [key: string]: boolean;
};

export const filterDocumentVersionToDisplay = (
  filters: Filters,
  documentActionsStatusState: DocumentActionsStatusState
): ((value: IDocumentVersion) => boolean) => {
  return (item) => {
    const documentActionsStatus = documentActionsStatusState.documentActionsStatus.get(item.parentDocument.id);
    if (filters.new && filters.ack) {
      return Boolean(documentActionsStatus?.isUnread) || Boolean(documentActionsStatus?.isAckRequired);
    }

    if (filters.new) {
      return Boolean(documentActionsStatus?.isUnread);
    }

    if (filters.ack) {
      return Boolean(documentActionsStatus?.isAckRequired);
    }

    return true;
  };
};

export const sortDocuments = (orderValue: ORDER_VALUES): ((a: IDocumentVersion, b: IDocumentVersion) => number) => {
  return (a, b) => {
    let valueA: string | number;
    let valueB: string | number;
    switch (orderValue) {
      case ORDER_VALUES.TITLE: {
        valueA = (a[orderValue] as string).toUpperCase();
        valueB = (b[orderValue] as string).toUpperCase();
        break;
      }
      case ORDER_VALUES.VERSION: {
        valueA = a[orderValue] as number;
        valueB = b[orderValue] as number;
        break;
      }
      case ORDER_VALUES.START_DATE: {
        valueA = new Date(a.startDate as any).getTime();
        valueB = new Date(b.startDate as any).getTime();
        break;
      }
      case ORDER_VALUES.ACK_DATE: {
        valueA = new Date(a.uds.ackDate as any).getTime();
        valueB = new Date(b.uds.ackDate as any).getTime();
        break;
      }
      default: {
        valueA = `${a.parentDocument.activityCode}_${a.parentDocument.serialNumber}${a.parentDocument.letter}`.toUpperCase();
        valueB = `${b.parentDocument.activityCode}_${b.parentDocument.serialNumber}${b.parentDocument.letter}`.toUpperCase();
        break;
      }
    }
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }

    return 0;
  };
};

export const computeStandardDocumentInfo = ({ activityCode, serialNumber, letter }: IParentDocument) => {
  const activityAndSerialNumber = `${activityCode}_${String(serialNumber)?.padStart(5, '0')}`;
  if (Boolean(letter)) {
    return activityAndSerialNumber.concat(`${letter}`);
  }
  return activityAndSerialNumber;
};

export const filterDocumentByTitle = (newDocTitle: string) => (documentVersion: IDocumentVersion) => {
  return `${computeStandardDocumentInfo(documentVersion.parentDocument)} ${documentVersion.title}`
    .toLowerCase()
    .includes(newDocTitle.toLowerCase());
};

export const getIsAckRequiredDocumentsCount = (documentVersions: IDocumentVersion[]) => {
  return documentVersions.filter((app) => app.uds.isAck).length || 0;
};

export const getStarredIsAckRequiredDocumentsCount = (documentVersions: IDocumentVersion[]) => {
  return documentVersions.filter((app) => app.uds.isFav && app.uds.isAck).length || 0;
};